import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SnackBarUI from '../../comman/SnackBarUI';
import { blockUnblockPublisherAction } from '../../redux/toolkit/publisher/blockUnblockPublisher';
import { getPublisherAction } from '../../redux/toolkit/publisher/getPublisher';

export default function BlockUnblockPublisherDailog({ blockAdmin, publisher_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const delCat = useSelector(state => state.deleteQuestionAnswer)
    const { status, message } = delCat

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        const publisherStatus = await dispatch(blockUnblockPublisherAction({
            block: blockAdmin,
            publisher_id: publisher_id
        }))
        if (publisherStatus?.payload?.status == 200) {
            dispatch(getPublisherAction())
        }
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to block this publisher?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={delCatHandle}> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}


BlockUnblockPublisherDailog.propTypes = {
    publisher_id: PropTypes.string,
    blockAdmin: PropTypes.boolean,
    state: PropTypes.any,
    setState: PropTypes.any
};